

















import { Component, Emit, Prop, Vue } from 'vue-property-decorator'

@Component({})
export default class CoreButton extends Vue {
    @Prop({ default: '' }) public title!: string
    @Prop({ default: 'headline-h4' }) public textClass!: string
    @Prop({ default: false }) public withBackground!: boolean
    @Prop({ default: false }) public centered!: boolean
    @Prop({ default: false }) public vCentered!: boolean
    @Prop({ default: false }) public outline!: boolean
    @Prop({ default: false }) public disabled!: boolean
    @Prop({ default: 'large' }) public size
    @Prop({ default: '' }) public color
    @Prop() public customColor

    public get additionalClasses(): string[] {
        return [
            this.withBackground ? 'has-background' : '',
            this.centered ? 'centered' : '',
            this.vCentered ? 'v-centered' : '',
            this.color,
            this.textClass,
            this.disabled ? 'disabled' : '',
            this.size === 'small' ? 'small' : '',
        ]
    }

    @Emit('click')
    public emitClick(e) {
        return e
    }

    public get nameClasses() {
        return {
            outline: this.outline,
            disabled: this.disabled,
        }
    }

    public onClick(e) {
        if (this.disabled) {
            e.preventDefault()
            e.stopPropagation()
            return
        }

        this.emitClick(e)
    }
}
